import React, { useContext, useEffect, useState } from "react";
import { LuSearch } from "react-icons/lu";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import SearchContext from "../../context/SearchContext";

const SearchBox = () => {
  const searchCtx = useContext(SearchContext);

  const handleSearchChange = (e) => {
    searchCtx.updateSearch(e.target.value);
  };

  return (
    <div
      className="search-box-container"
    >

      <input
        type="text"
        value={searchCtx.searchValue}
        placeholder="Search for products, categories..."
        onChange={handleSearchChange}
        style={{
          flexGrow: 1,
          border: "none",
          backgroundColor: "transparent",
          outline: "none",
          padding: "10px 10px 10px 16px",
          fontSize: "14px",
        }}
      />


      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 16px",
          cursor: "pointer",
        }}
      >
        <LuSearch style={{ fontSize: "20px", color: "#777" }} />
      </div>
    </div>
  );
};

export default SearchBox;